import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import MuiSnackbar from '@material-ui/core/Snackbar';
import { Alert } from '@components/atoms';

const useStyles = makeStyles((theme) => ({
    close: {
        padding: theme.spacing(0.5),
    },
}));

const Snackbar = (props) => {
    const { anchorOrigin, openSnackbar, autoHideDuration, onClose, snackbarMessage, action, children, alertProps, alertMessage, ...rest } = props;

    return (
        <MuiSnackbar
            anchorOrigin={anchorOrigin}
            open={openSnackbar}
            autoHideDuration={autoHideDuration}
            onClose={onClose}
            message={snackbarMessage}
            action={action}
            {...rest}
        >{children ? children : <Alert onClose={onClose}  {...alertProps}>{alertMessage}</Alert>}</MuiSnackbar>
    );
};

Snackbar.propTypes = {
    anchorOrigin: PropTypes.object,
    open: PropTypes.bool.isRequired,
    autoHideDuration: PropTypes.number,
    onClose: PropTypes.func,
    snackbarMessage: PropTypes.string,
    alertMessage: PropTypes.string,
    action: PropTypes.any,
    alertProps: PropTypes.object,

}

Snackbar.defaultProps = {
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
    },
    autoHideDuration: 4000,
    snackbarMessage: '',
    alertMessage: '',
    onClose: () => { },
    alertProps: {
        severity: "success"
    },
}

export default Snackbar;